<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="'pages.alertSetting.title' | translate"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <div class="md:tw-w-1/3">
          <fieldset class="tw-h-full">
            <legend>
              {{ "common.alertSetting" | translate }}
            </legend>

            <div class="row">
              <form-field
                [control]="form.get('daysOfSendFrequencyPeriod')"
                type="number"
                class="tw-w-full"
                label="common.daysOfSendFrequencyPeriod"
                [(value)]="model.daysOfSendFrequencyPeriod"
              >
              </form-field>

              <mat-slide-toggle
                formControlName="isEnableSendNotification"
                [(ngModel)]="model.isEnableSendNotification"
              >
                {{ "common.isEnableSendNotification" | translate }}
              </mat-slide-toggle>
            </div>
          </fieldset>
        </div>
      </div>
      <section class="tw-mt-5">
        <fieldset>
          <legend>
            {{ "common.importanceLevel" | translate }}
          </legend>

          <div class="row tw-mt-5" *ngIf="!notificationImportanceLevelLoading">
            <div
              *ngFor="
                let item of NotificationImportanceLevelEnumValues;
                let i = index
              "
              class="sm:tw-w-1/2 xl:tw-w-1/3"
            >
              <app-alert-setting
                [notificationImportanceLevel]="item"
                [notificationImportanceLevels]="
                  NotificationImportanceLevelEnumValues
                "
                [modelItems]="model.importanceLevels"
                [counter]="i"
                (items)="getItems($event)"
              ></app-alert-setting>
            </div>
          </div>

          <div class="row" *ngIf="notificationImportanceLevelLoading">
            <div
              class="tw-flex tw-justify-center tw-items-center role-organizations-loading"
            >
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <span class="text-primary tw-text-lg tw-font-medium tw-mx-2">{{
                "common.loading" | translate
              }}</span>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
